import { addDisplayName, addHandlers, addProps, flowMax } from 'ad-hok'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'
import { trackEvent } from 'shared/src/utils/analytics'
import { CurrentUser } from 'shared/src/api/types'
import cx from 'classnames'

import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import { sansSerifFontFamily, serifFontFamily } from 'utils/styles'
import { LinkOrButton } from './LinkOrButton'
import { CREATOR_APP_URL, WAITLIST_URL } from 'utils/urls'

export const JOIN_CREATOR_WAITLIST_BUTTON_BOTTOM_MARGIN = 32
export const JOIN_CREATOR_WAITLIST_BUTTON_HEIGHT = 72

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
  },
  prompt: {
    textAlign: 'center',
    fontFamily: serifFontFamily,
    fontStyle: 'italic',
    fontWeight: 800,
    fontSize: 20,
    lineHeight: '140%',
    letterSpacing: '0.01em',
    color: 'rgba(255, 255, 255, 0.24)',
    margin: 0,
    marginBottom: 17,
  },
  button: {
    height: JOIN_CREATOR_WAITLIST_BUTTON_HEIGHT,
    borderRadius: 16,
    backgroundImage:
      'radial-gradient(103.73% 266.85% at 0% 16.08%, #CF8355 0%, #CEAF85 38.44%, #9B876D 100%)',
    backgroundSize: 'cover',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: sansSerifFontFamily,
    fontWeight: 800,
    fontSize: 14,
    letterSpacing: '0.1em',
    color: 'white',
    textDecoration: 'none',
  },
})

interface Props {
  user?: CurrentUser
  className?: string
}

export const JoinWaitlistOrLaunchCmsButton: FC<Props> = flowMax(
  addDisplayName('JoinWaitlistOrLaunchCmsButton'),
  addHandlers({
    onClick: () => () => {
      trackEvent(
        {
          category: 'general',
          action: 'navigate',
        },
        {
          url: WAITLIST_URL,
        }
      )
    },
  }),
  addProps(() => ({
    classes: useStyles(),
  })),
  addTranslationHelpers,
  ({ user, onClick, classes, className, t }) => (
    <div className={cx(classes.container, className)}>
      {user && user.isCreator ? (
        <LinkOrButton
          navigateTo={CREATOR_APP_URL}
          external
          className={classes.button}
        >
          {t('menu.creatorAppLink')}
        </LinkOrButton>
      ) : (
        <LinkOrButton
          navigateTo={WAITLIST_URL}
          external
          onClick={onClick}
          className={classes.button}
        >
          {t('menu.waitlist')}
        </LinkOrButton>
      )}
    </div>
  )
)
